module.exports = __webpack_public_path__ + "static/media/map.049d9973.png";